import { CardContent, Stack } from "@mui/material";
import { useFavoriteWorkplacesFlag } from "@src/appV2/FeatureFlags/useFavoriteWorkplacesFlag";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import {
  Card,
  CbhIcon,
  Divider,
  type IconType,
  Illustration,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";
import { Fragment } from "react";

import { Button } from "../../components/Button";

const LIST_ITEMS: Array<{
  key: number;
  iconType: IconType;
  primaryText: string;
}> = [
  {
    key: 1,
    iconType: "bell-outlined",
    primaryText: "Be notified immediately about new postings",
  },
  {
    key: 2,
    iconType: "priority",
    primaryText:
      "Priority Access on new shifts for 15 minutes before others professionals can see them",
  },
  {
    key: 3,
    iconType: "like-outlined",
    primaryText: "View your favorite shifts all in one place",
  },
];

interface NoFavoriteWorkplacesEmptyStateProps {
  pickerModalState: UseModalState;
}

export function NoFavoriteWorkplacesEmptyState(props: NoFavoriteWorkplacesEmptyStateProps) {
  const { pickerModalState } = props;
  const { maxFavoriteCount, clipboardScoreThreshold } = useFavoriteWorkplacesFlag();

  return (
    <Stack sx={{ px: 7, mt: 4 }} justifyContent="center" alignItems="center" gap={6}>
      <Stack alignItems="center" gap={2}>
        <Illustration type="facility" />

        <Text semibold variant="h5" textAlign="center">
          Having a {clipboardScoreThreshold}+ Clipboard Score earned your first access to shifts at
          your favorite workplaces
        </Text>
      </Stack>

      <Card
        sx={{
          border: "2px solid",
          borderColor: "divider",
          width: "100%",
          maxWidth: 420,
        }}
      >
        <CardContent>
          <Text semibold variant="h6" sx={{ mt: 2, mb: 4 }}>
            Choose up to {maxFavoriteCount} {pluralize("workplace", maxFavoriteCount)} to...
          </Text>
          <Divider sx={{ my: 4 }} />
          <List dense>
            {LIST_ITEMS.map((item, index) => (
              <Fragment key={item.key}>
                <ListItem alignItems="center">
                  <ListItemIcon>
                    <CbhIcon type={item.iconType} size="small" />
                  </ListItemIcon>
                  <ListItemText primary={<Text variant="body2">{item.primaryText}</Text>} />
                </ListItem>
                {index !== LIST_ITEMS.length - 1 && <Divider sx={{ my: 4 }} />}
              </Fragment>
            ))}
          </List>
        </CardContent>
      </Card>

      <Button
        variant="contained"
        size="large"
        startIconType="like-outlined"
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.CHOOSE_FAVORITE_WORKPLACES_BUTTON_CLICKED);
          pickerModalState.openModal();
        }}
      >
        Choose Workplaces
      </Button>
    </Stack>
  );
}
